import { Box, List, ListItem, PopoverOrigin, Typography } from '@mui/material';
import PopupState, { bindHover, bindPopover } from 'material-ui-popup-state';
import HoverPopover from 'material-ui-popup-state/HoverPopover';

import { InfoOutlinedIcon } from '@occc/ui-design-system';

import {
  MISSING_STORES_GREEN_BAR_COLOR,
  MISSING_STORE_YELLOW_BAR_COLOR,
  MISSING_STORES_RED_BAR_COLOR,
  MISSING_STORES_LOW_THRESHOLD,
  MISSING_STORES_MEDIUM_THRESHOLD,
} from '../scan-data-overview.constants';

type ColorGuideItemProps = {
  color: string;
  label: string;
  description: string;
};

const ColorGuideItem = ({ color, label, description }: ColorGuideItemProps) => (
  <ListItem sx={{ py: 0.5, px: 0 }}>
    <Typography variant='body2'>
      <Box component='span' sx={{ fontWeight: 600, color }}>
        {label}
      </Box>
      {description}
    </Typography>
  </ListItem>
);

const ANCHOR_ORIGIN: PopoverOrigin = {
  vertical: 'bottom',
  horizontal: 'left',
};

const TRANSFORM_ORIGIN: PopoverOrigin = {
  vertical: 'top',
  horizontal: 'left',
};

export const ScanDataMissingStoresInfo = () => {
  return (
    <PopupState variant='popover' popupId='missing-stores-info'>
      {(popupState) => (
        <>
          <Box
            display='flex'
            justifyContent='center'
            alignItems='center'
            ml={0.5}
            sx={{ cursor: 'pointer' }}
            {...bindHover(popupState)}
          >
            <InfoOutlinedIcon sx={{ fontSize: '2rem', color: 'text.disabled' }} />
          </Box>

          <HoverPopover
            {...bindPopover(popupState)}
            anchorOrigin={ANCHOR_ORIGIN}
            transformOrigin={TRANSFORM_ORIGIN}
          >
            <Box p={2}>
              <List dense sx={{ py: 0 }}>
                <ColorGuideItem
                  color={MISSING_STORES_GREEN_BAR_COLOR}
                  label='Green Bar'
                  description={` - Less than or equal to ${MISSING_STORES_LOW_THRESHOLD}% of stores missing`}
                />
                <ColorGuideItem
                  color={MISSING_STORE_YELLOW_BAR_COLOR}
                  label='Yellow Bar'
                  description={` - More than ${MISSING_STORES_LOW_THRESHOLD}% and less than or equal to ${MISSING_STORES_MEDIUM_THRESHOLD}% of stores missing`}
                />
                <ColorGuideItem
                  color={MISSING_STORES_RED_BAR_COLOR}
                  label='Red Bar'
                  description={` - More than ${MISSING_STORES_MEDIUM_THRESHOLD}% of stores missing`}
                />
              </List>
            </Box>
          </HoverPopover>
        </>
      )}
    </PopupState>
  );
};
